<div class="row">
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="no-left-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <ng-container *ngIf="showLegacy; then legacyModelTemplate else regulationModelDeviceTemplate">
                  </ng-container>
                  <ng-template #legacyModelTemplate>
                    <tr>
                      <th class="col-sm-6">EUDAMED DI</th>
                      <th class="col-sm-6">EUDAMED DI Issuing Agency</th>
                    </tr>
                    <tr>
                      <td>
                        <label controlName="eudamedDI"></label>
                      </td>
                      <td><label controlName="eudamedDiIssuingAgency"></label></td>
                    </tr>
                  </ng-template>
                  <ng-template #regulationModelDeviceTemplate>
                    <tr>
                      <th>Basic UDI-DI</th>
                      <th>Issuing Agency</th>
                    </tr>
                    <tr>
                      <td>
                        <label controlName="budi"></label>
                      </td>
                      <td><label controlName="bAgency"></label></td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>

            </td>

            <td class="col-sm-6 no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>Applicable Legislation</th>
                    <th>Device Risk Class</th>
                  </tr>
                  <tr>
                    <td><label
                        controlName="applicableLegislation"></label></td>
                    <td><label controlName="deviceRiskClass"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="col-sm-6 no-left-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>Device Model</th>
                  </tr>
                  <tr>
                    <td><label controlName="deviceModel"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>

            <td class="col-sm-6 no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>Device Name</th>
                  </tr>
                  <tr>
                    <td><label controlName="deviceName"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="no-left-padding">
              <table class="table table-inner table-condensed table-striped" *ngIf=!sppModel>
                <tbody>
                  <tr>
                    <th>Manufacturer SRN</th>
                  </tr>
                  <tr>
                    <td>
                      <label controlName="manufacturerSRN"></label>
                    </td>

                  </tr>
                </tbody>
              </table>
              <table class="table table-inner table-condensed table-striped" *ngIf="!sppModel && dataScope?.toLowerCase() === 'swissdamed'">
                <tbody>
                  <tr>
                    <th>Manufacturer CHRN</th>
                  </tr>
                  <tr>
                    <td>
                      <label controlName="manufacturerChrn"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table table-inner table-condensed table-striped" *ngIf=sppModel>
                <tbody>
                  <tr>
                    <th>System or Procedure Pack Producer SRN
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <label controlName="sppProducerSRN"></label>
                    </td>

                  </tr>
                </tbody>
              </table>
              <table class="table table-inner table-condensed table-striped" *ngIf="sppModel && dataScope?.toLowerCase() === 'swissdamed'">
                <tbody>
                  <tr>
                    <th>System or Procedure Pack Producer CHRN</th>
                  </tr>
                  <tr>
                    <td>
                      <label controlName="systemProcedurePackChrn"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>


            <td  class="col-sm-6 no-right-padding">
                <table class="table table-inner table-condensed table-striped" *ngIf=!sppModel>
                  <tbody>
                    <tr>
                      <th *ngIf="applicableRegulation != 'IVDR'">Multi-Component Device Type</th>
                      <th>Special Device Type</th>
                    </tr>
                    <tr>
                      <td *ngIf="applicableRegulation != 'IVDR'"> <label
                          controlName="multiComponentDeviceType"></label></td>
                          <td> <label controlName="specialDeviceType"></label>
                          </td>
                    </tr>
                  </tbody>
                </table>
                <table class="table table-inner table-condensed table-striped" *ngIf=sppModel>
                  <tbody>
                    <tr>
                      <th>System or Procedure Pack Type
                      </th>
                      <th *ngIf="dataScope?.toLowerCase() === 'swissdamed'">Special Device Type</th>
                    </tr>
                    <tr>
                      <td>
                        <label controlName="sppType"></label>
                      </td>
                      <td *ngIf="dataScope?.toLowerCase() === 'swissdamed'">
                        <label controlName="specialDeviceType"></label>
                      </td>
                    </tr>
                  </tbody>
                </table>
            </td>
          </tr>
          <tr *ngIf="itemDetails">
            <td class="no-left-padding" *ngIf="applicableRegulation != 'IVDR' && applicableRegulation != 'MDR'">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>System or Procedure Pack Producer SRN</th>
                  </tr>
                  <tr>
                    <td> <label controlName="sppProducerSRN"></label>
                  </tr>
                </tbody>
              </table>
              <table class="table table-inner table-condensed table-striped" *ngIf="dataScope?.toLowerCase() === 'swissdamed'">
                <tbody>
                  <tr>
                    <th>System or Procedure Pack Producer CHRN</th>
                  </tr>
                  <tr>
                    <td>
                      <label controlName="systemProcedurePackChrn"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="col-md-12 no-right-padding" *ngIf="applicableRegulation != 'IVDR' && applicableRegulation != 'MDR'">

                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th>System or Procedure Pack Type</th>
                    </tr>
                    <tr>
                      <td><label controlName="sppType"></label></td>
                    </tr>
                  </tbody>
                </table>

            </td>
          </tr>
          <tr *ngIf=!sppModel>
            <td class="no-left-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>Authorized Representative SRN</th>
                  </tr>
                  <tr>
                    <td><label controlName="authRepSRN"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="col-sm-6 no-right-padding" *ngIf="dataScope?.toLowerCase() === 'swissdamed'">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>Authorized Representative CHRN</th>
                  </tr>
                  <tr>
                    <td><label controlName="authorizedRepChrn"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>

